// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailFlows_root__ZsaYG {
  width: 100%;
  color: var(--color-font-10);
  overflow: scroll;
  height: calc(100vh - 133px);
  overflow-y: scroll;
}

.EmailFlows_flow_list_container__y2yij {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 210px;
  top: 91px;
  width: 290px;
  background-color: var(--color-bg-caselist);
  overflow: scroll;
  padding: 10px;
  overflow-x: hidden;
  height: calc(100vh - 140px);
  z-index: 100;
}

.EmailFlows_new_flow_button__SKpcD {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  align-self: center;
  background-color: var(--color-bg-caselist-item);
}

/* add flow row  */
.EmailFlows_email_flow_input__2Bvt9 {
  background-color: var(--color-bg-caselist-item);
  outline: none;
  border: none;
  color: var(--color-font-10);
  font-weight: bold;
  font-size: 16px;
}

.EmailFlows_email_row_root__5g0tQ {
  margin-top: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.EmailFlows_email_row_root__5g0tQ:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
}

.EmailFlows_account_tree_icon__JjY9V {
  margin: 0px 10px;
}
/* template details */
.EmailFlows_template_container__4ib-W {
  overflow: hidden;
  margin-left: 310px;
  background-color: var(--color-bg-content);
}

.EmailFlows_template_no_data__KkFgg {
  text-align: center;
  margin-top: 300px;
  text-transform: uppercase;
  font-size: 24px;
  color: var(--color-theme-silver);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/EmailFlows/EmailFlows.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAGlB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,+CAA+C;EAC/C,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;AACA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC","sourcesContent":[".root {\n  width: 100%;\n  color: var(--color-font-10);\n  overflow: scroll;\n  height: calc(100vh - 133px);\n  overflow-y: scroll;\n}\n\n.flow_list_container {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  left: 210px;\n  top: 91px;\n  width: 290px;\n  background-color: var(--color-bg-caselist);\n  overflow: scroll;\n  padding: 10px;\n  overflow-x: hidden;\n  height: -webkit-calc(100vh - 105px);\n  height: -moz-calc(100vh - 105px);\n  height: calc(100vh - 140px);\n  z-index: 100;\n}\n\n.new_flow_button {\n  margin: 0 auto;\n  width: fit-content;\n  text-align: center;\n  align-self: center;\n  background-color: var(--color-bg-caselist-item);\n}\n\n/* add flow row  */\n.email_flow_input {\n  background-color: var(--color-bg-caselist-item);\n  outline: none;\n  border: none;\n  color: var(--color-font-10);\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.email_row_root {\n  margin-top: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.email_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n}\n\n.account_tree_icon {\n  margin: 0px 10px;\n}\n/* template details */\n.template_container {\n  overflow: hidden;\n  margin-left: 310px;\n  background-color: var(--color-bg-content);\n}\n\n.template_no_data {\n  text-align: center;\n  margin-top: 300px;\n  text-transform: uppercase;\n  font-size: 24px;\n  color: var(--color-theme-silver);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EmailFlows_root__ZsaYG`,
	"flow_list_container": `EmailFlows_flow_list_container__y2yij`,
	"new_flow_button": `EmailFlows_new_flow_button__SKpcD`,
	"email_flow_input": `EmailFlows_email_flow_input__2Bvt9`,
	"email_row_root": `EmailFlows_email_row_root__5g0tQ`,
	"account_tree_icon": `EmailFlows_account_tree_icon__JjY9V`,
	"template_container": `EmailFlows_template_container__4ib-W`,
	"template_no_data": `EmailFlows_template_no_data__KkFgg`
};
export default ___CSS_LOADER_EXPORT___;
